module.exports = __webpack_public_path__ + "static/img/web_right_prop.1f3178a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_right_prop.png
// module id = p6v+
// module chunks = 0